var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoOnlyMedincenter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.1725 30.0863H41.4318C42.0603 30.0863 42.663 29.8366 43.1075 29.3922C43.5519 28.9478 43.8015 28.345 43.8015 27.7165V16.0654C43.8015 15.7542 43.7402 15.446 43.6211 15.1585C43.5021 14.871 43.3275 14.6098 43.1075 14.3897C42.8874 14.1697 42.6262 13.9951 42.3387 13.876C42.0512 13.7569 41.743 13.6956 41.4318 13.6956H37.1725C29.9549 13.6956 28.9636 17.8117 28.9636 21.889C28.9636 25.9663 29.9549 30.0863 37.1725 30.0863Z",
    fill: "#005349"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.6213 13.6956H2.36198C1.73484 13.6977 1.13407 13.9483 0.691337 14.3924C0.2486 14.8366 -3.34886e-06 15.4382 0 16.0654L0 27.7165C0 28.345 0.249667 28.9478 0.694077 29.3922C1.13849 29.8366 1.74124 30.0863 2.36973 30.0863H6.62905C13.835 30.0863 14.8263 25.9896 14.8263 21.889C14.8263 17.7884 13.8273 13.6956 6.6213 13.6956Z",
    fill: "#005349"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0859 6.6213V2.36198C30.0839 1.73484 29.8333 1.13407 29.3891 0.691337C28.9449 0.2486 28.3434 -3.34886e-06 27.7162 0L16.065 0C15.4366 0 14.8338 0.249667 14.3894 0.694077C13.945 1.13849 13.6953 1.74124 13.6953 2.36973V6.62905C13.6953 13.835 17.792 14.8263 21.8887 14.8263C25.9854 14.8263 30.0859 13.8273 30.0859 6.6213Z",
    fill: "#005349"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6953 37.1722V41.4315C13.6953 42.06 13.945 42.6628 14.3894 43.1072C14.8338 43.5516 15.4366 43.8013 16.065 43.8013H27.7162C28.3447 43.8013 28.9474 43.5516 29.3919 43.1072C29.8363 42.6628 30.0859 42.06 30.0859 41.4315V37.1722C30.0859 29.9662 25.9892 28.975 21.8887 28.975C17.7881 28.975 13.6953 29.9546 13.6953 37.1722Z",
    fill: "#005349"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoOnlyMedincenter);
export default __webpack_public_path__ + "static/media/logo_only_medincenter.64a5a79ec48cac43d2bb0c2ee37a065b.svg";
export { ForwardRef as ReactComponent };